import * as RadixTabs from '@radix-ui/react-tabs';
import clsx from 'clsx';
import { TabsProps, TabsType } from './Tabs.types';
import TabsContent from './TabsContent';
import TabsList from './TabsList';

const Tabs = ({ activeTab, tabs, setActiveTab, className, type = TabsType.BOXED }: TabsProps) => {
  return (
    <RadixTabs.Root value={activeTab} className={clsx('flex h-full min-h-0 flex-col gap-4', className)}>
      <TabsList activeTab={activeTab} tabs={tabs} type={type} setActiveTab={setActiveTab} />
      <TabsContent tabs={tabs} />
    </RadixTabs.Root>
  );
};

export default Tabs;
